import request from './../utils/request';

export function index(params) {
  return request({
    url: '/categories',
    method: 'GET',
    params
  });
}

export function show(id) {
  return request({
    url: '/categories/' + id,
    method: 'GET'
  });
}

export function store(data) {
  return request({
    url: '/categories',
    method: 'POST',
    data
  });
}

export function update(data) {
  return request({
    url: '/categories/' + data.id,
    method: 'PUT',
    data
  });
}

export function destroy(id) {
  return request({
    url: '/categories/' + id,
    method: 'DELETE'
  });
}

export function inventory(params) {
  return request({
    url: '/categories/inventory',
    method: 'GET',
    params
  });
}